export const authScreens = [
  { name: "login" },
  { name: "forgot-password" },
  { name: "reset-password" },
  { name: "set-password" },
];
